export function prettyTimeAgo(timestamp: string): string {
  const diff = Math.floor((Date.now() - new Date(timestamp).getTime()) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function prettyTimeDiff(a: string, b: string): string {
  const diff = Math.abs(new Date(a).getTime() - new Date(b).getTime()) / 1000;
  if (diff < 60) return `${Math.round(diff)}s`;
  if (diff < 3600) return `${Math.round(diff / 60)}m`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h`;
  return `${Math.round(diff / 86400)}d`;
}

export function formatTs(ts: string): string {
  return new Date(ts).toLocaleString();
}

export function nanoToMs(ns: number): number {
  return Math.trunc(ns / 1_000_000);
}
